export default "__VITE_ASSET__DXpnkDDq__"